// RJSF's built-in ArrayFieldTemplate ignores minItems when deciding whether "Remove" is shown,
// so this wraps it to flag items that are at the schema-defined minimum. Pairs with
// MinItemsArrayFieldItemTemplate, which disables (rather than hides) Remove for those items so
// the toolbar keeps its usual button layout instead of reflowing.
export default function MinItemsArrayFieldTemplate(props) {
  const { items, schema } = props;
  const { ArrayFieldTemplate: DefaultArrayFieldTemplate } = props.registry.templates;
  const atMinimum = items.length <= (schema.minItems || 0);
  const guardedItems = items.map((item) => ({ ...item, disableRemove: atMinimum }));

  return (
    <DefaultArrayFieldTemplate
      {...props}
      items={guardedItems}
    />
  );
}
